import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
function NoTrackedMeetingsEmptyContent(_ref) {
  var isCurrentUser = _ref.isCurrentUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Landmark, {
    icon: "asset-fluidbook"
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t(isCurrentUser ? 'skills_empty_state_you_have_no_tracked_meetings' : 'skills_empty_state_person_has_no_tracked_meetings')));
}
export default NoTrackedMeetingsEmptyContent;